import { Component, Output, EventEmitter, Input, OnInit, OnChanges, SimpleChanges, forwardRef } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpRequest, HttpResponse } from '@angular/common/http';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { DomSanitizer } from '@angular/platform-browser';


import { UtilService } from '../../utils/util.service';
import { ModalConfigService } from '../../utils/modal-config.service';
import { DownloadFileService } from '../../service/downloadFile.service';
import { UploadService } from './upload.service';
import { GlobalCacheService } from '../../service/global-cache.service';
import { globalConst } from '../../../shared/constant/constant';


// import OSS from 'src/assets/lib/aliyun-upload-sdk-1.5.3/aliyun-upload-sdk-1.5.3.min.js';
declare var OSS: any;
// import 'src/assets/lib/aliyun-upload-sdk-1.5.3/lib/aliyun-oss-sdk-6.17.1.min.js';
declare var AliyunUpload: any;

/**
 *
 * 支持 自定义表单 formControlName
 * <app-file-upload formControlName="upload" placeholder="上传图片" [fileType]="fileFormat.image_gif" dataType='string'></app-file-upload>
 *
 * 支持 双向数据绑定
 * <app-file-upload [(fileList)]="fileList" placeholder="上传图片" [fileType]="fileFormat.image_gif" dataType='string'></app-file-upload>
 *
 */

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileUploadComponent),
      multi: true
    }
  ]
})

export class FileUploadComponent implements OnInit, OnChanges, ControlValueAccessor {
  constructor(
    private utilService: UtilService,
    private globalCacheService: GlobalCacheService,
    private modalMessageService: ModalConfigService,
    private downloadFileService: DownloadFileService,
    private uploadService: UploadService,
    private cookieService: CookieService,
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) { }

  @Input() uploadStyle = 1; // 素材库样式

  @Input() placeholder = '文件上传';
  /**
   * api 上传接口
   */
  @Input() uploadImgUrl = '/a/u/img/thumb';
  /**
   * 自定义上传参数
   */
  @Input() extraData: any = {};
  /**
   * 上传组件样式
   */
  @Input() nzListType = 'picture-card';
  /**
   * 接受上传的文件类型, 详见 input accept Attribute  待定
   */
  @Input() nzAccept = '';

  @Input() fileType = globalConst.File_Format.image;  // 上传格式

  @Input() sizeHint = '';  // 上传提示文字

  @Input() fileSize = null; // 文件大小上限，单位 MB

  @Input() fileTypeShow = true; // 是否显示文件格式提示

  @Input() showDownloadIcon = false; // 是否显示下载按钮

  @Input() limit = 1; // 上传数量

  @Input() nzMultiple = false; // 上传多张

  @Input() disableUpload = false; // 禁用
  /**
   * 支持上传文件夹
   */
  @Input() nzDirectory = false;
  /**
   * 上传方式
   * 1、'API' ==> 服务端签名直传
   * 2、'KS3' ==> 金山云oss直传 https://docs.ksyun.com/documents/2321
   * 3、'aliyun' ==> 阿里云oss直传 https://help.aliyun.com/document_detail/31923.html
   */
  public uploadHost = 'api';
  /**
   * 组件输出数据类型
   *
   * string  例如：'http://ks3-cn-beijing.ksyun.com/jns.img.bucket/xxx.png'  ( 请将 limit 设为 1， 默认返回文件列表的第一个的url 没有则返回 '')
   * json    例如："[{"url":"http://ks3-cn-beijing.ksyun.com/jns.img.bucket/thumb/xxx.jpg", name: xxx}]"
   * array   例如：[{url: 'xxx.png' , name: xxx}] 或 []
   * object  例如：{url: 'xxx.png', name: xxx } 或 {}  未完成!!!!!!!!!!!!!!!!!!
   */
  @Input() dataType = 'array';
  /**
   * 传入数据
   * 和 fileListChange 配合完成双向数据绑定。
   */
  @Input() fileList: string | Array<{ url: string }> = [];
  /**
   * 上传完成回调  返回根据 入参dataType要求的格式
   */
  @Output() fileListChange = new EventEmitter();
  /**
   * 上传完成的回调  直接返回接口返回的数据
   * 应用场景：
   * 1、表格的批量导入(需要自定义上传地址（uploadImgUrl）、自定义上传参数（extraData）
   * 2、待定。。
   */
  @Output() ngModelChange = new EventEmitter();
  /**
   * 文档正在上传中
   * 应用场景：文件未上传完成，不允许保存
   */
  @Output() uploadStatus = new EventEmitter();
  /**
   * 是否是编辑
   * 和 配合fileList展示空数据状态查看的样式。
   */
  @Input() isEdit?: boolean = true;

  public nzFileList: Array<{ url: string }> = []; // 组件内图片缩略图展示数据
  public outputValue: any; // 输出数据
  public nzShowUploadList = { showPreviewIcon: true, showRemoveIcon: true, showDownloadIcon: true }; // 上传设置
  public previewUrl = '';
  public previewType = '';
  public previewVisible = false;
  public uploadMethod = false; // 上传方式弹窗

  public canceler = {};  // 储存文件上传函数订阅信息 （用于 直传oss 是使用，）
  public aliyunInitVODUpload;



  ngOnInit(): any {
    this.nzShowUploadList.showRemoveIcon = !this.disableUpload;
    this.nzShowUploadList.showDownloadIcon = !this.showDownloadIcon;
    const { module } = this.globalCacheService?.merchant?.config || {};
    this.uploadHost = module && module.upload && module.upload.host ? module.upload.host : 'KS3';
  }

  ngOnChanges(changes: SimpleChanges): any {
    if (changes.fileList) {
      this.parseData(this.fileList);
    }
  }

  // ---------------自定义表单-----------------

  /**
   * 自定义表单
   */
  get formData(): any {
    return this.nzFileList || [];
  }
  set formData(value: any) {
    this.nzFileList = value;
    this.propagateChange(this.formattingOutputValue(JSON.parse(JSON.stringify(value))));
  }
  /**
   * model->view
   * @param value 表单传入值
   */
  writeValue(value: any): void {
    if (value) {
      this.parseData(value);
    }
  }
  /**
   * view->model
   * @param fn 表单输出值
   * 设置当控件接收到 change 事件后，调用的函数
   */
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  propagateChange = (_: any) => { };

  /**
   * 设置当控件接收到 touched 事件后，调用的函数
   * @param fn //
   */
  registerOnTouched(fn: any): void { }
  /**
   * 禁用表单
   * 当控件状态变成 DISABLED 或从 DISABLED 状态变化成 ENABLE 状态时，会调用该函数。该函数会根据参数值，启用或禁用指定的 DOM 元素。
   * @param isDisabled //
   */
  setDisabledState?(isDisabled: boolean): void {
    this.disableUpload = isDisabled;
  }

  // ---------------自定义表单-----------------






  // --------------- 公共方法 -----------------

  // 解析数据
  parseData(value): any {
    if (value) {
      if (Array.isArray(value) && value.length) {
        this.formData = value;
      } else if (value.includes('[') && value.includes(']')) {
        this.formData = this.utilService.getJSONParse(value, []);
      } else if (value.includes('http')) {
        this.formData = [{ url: value }];
      } else if (value.includes('/') || value.includes('-') || value.includes('.')) {
        this.formData = [{ url: value }];
      } else {
        this.formData = [];
      }
    }
  }

  // 点删除
  nzRemove = (file: NzUploadFile) => {
    // 取消请求
    const removeItem = this.canceler[file.uid];
    if (removeItem) {
      if (removeItem.type === 'aliyun_Vod') {
        this.aliyunInitVODUpload.cleanList();
      } else {
        this.canceler[file.uid].unsubscribe();
      }
    }
    return true;
  }

  sanitize(url: string): any {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  // --------------- 公共方法 -----------------











  // ---------------金山云上传开始-----------------

  customRequestKS3 = async (item: NzUploadFile) => {
    // 获取上传配置
    const { data: imgOptions } = await this.uploadService.getImgOptions('js');

    const merchantId = this.cookieService.get('merchants');

    const fileName = item.file.name;
    const flieArr = fileName.split('.');
    const suffix = flieArr[flieArr.length - 1];
    const Key = this.uploadService.getUUID() + '.' + suffix;

    return this.canceler[item.file.uid] = this.uploadService.Ks3_fileUpload({
      Bucket: imgOptions.bucket,
      Key,
      File: item.file,
      ACL: 'public-read',
      region: 'BEIJING',
      Sinature: imgOptions.signature,
      merchantId,
    }).subscribe((event: HttpEvent<{}> | any) => {
      if (event.type === HttpEventType.UploadProgress) {
        if (event.total > 0) {
          (event as any).percent = (event.loaded / event.total) * 100;
        }
        // 处理上传进度条，必须指定 `percent` 属性来表示进度
        if (this.nzFileList.length) {
          item.onProgress({ percent: event.percent || 0 }, item.file);
        }
      } else if (event instanceof HttpResponse) {
        const res = {
          code: 0,
          data: {
            url: `http://${imgOptions.domain}/${imgOptions.bucket}/${merchantId}/${Key}`,
            coverUrl: ''  // TODO 金山云视频截图，没做。
          }
        };
        // 处理成功
        item.onSuccess(res, item.file, '');
      }
    },
      err => {
        // 处理失败
        item.onError(err, item.file);
      }
    );
  }

  // ---------------金山云上传结束-----------------












  // ---------------阿里云上传开始-----------------

  customRequestAliyun = async (item: NzUploadFile) => {
    // 获取上传配置
    const { data: config } = await this.uploadService.getImgOptions('ali');
    const fileName = item.file.name;
    const flieArr = fileName.split('.');
    const suffix = flieArr[flieArr.length - 1].toLocaleLowerCase();
    // suffix = suffix.toLocaleLowerCase();
    const key = this.uploadService.getUUID() + '.' + suffix;

    const fileType = this.utilService.getFileType(fileName);

    if (fileType === 'video' && suffix === 'mov') {

      // TODO 视频点播暂时支持单个文件上传，待优化。。。。。
      // 问题点1：多个文件下的进度条处理
      // 问题点2：中断上传、删除文件处理。

      // 视频点播上传
      this.aliyunInitVODUpload = new AliyunUpload.Vod({
        userId: '123456',
        retryCount: 3,
        // 网络原因失败时，重新上传间隔时间，默认为2秒
        retryDuration: 2,
        // 开始上传
        onUploadstarted: async (uploadInfo) => {
          // 获取上传配置
          const { data: uploadVodConfig } = await this.uploadService.aliyunUploadVodConfigRequest(uploadInfo.file);
          this.aliyunInitVODUpload.setUploadAuthAndAddress(uploadInfo, uploadVodConfig.uploadAuth, uploadVodConfig.uploadAddress, uploadVodConfig.videoId);
        },
        // 文件上传成功
        onUploadSucceed: async (uploadInfo) => {
          const bucket = uploadInfo.bucket;
          const object = uploadInfo.object;
          const region = uploadInfo.region;
          const url = `https://${bucket}.oss-${region}.aliyuncs.com/${object}`;
          // 视频封面
          const coverUrl = await this.uploadService.aliyun_cover_Upload(url);
          const res = {
            code: 0,
            data: {
              url,
              coverUrl,
              videoId: uploadInfo.videoId,
              fileFormat: suffix,
              fileType
            }
          };
          // 上传成功
          item.onSuccess(res, item.file, '');
        },
        // 文件上传失败
        onUploadFailed: (uploadInfo, code, message) => {
          item.onError(message, item.file);
        },
        // 文件上传进度，单位：字节
        onUploadProgress: (uploadInfo, totalSize, loadedPercent) => {
          const progressPercent = Math.ceil(loadedPercent * 100);
          // 上传进度
          item.onProgress({ percent: progressPercent || 0 }, item.file);
        },
      });
      // 添加上传文件
      this.aliyunInitVODUpload.addFile(item.file, null, null, null, '{"Vod":{}}');
      // 开始上传
      this.aliyunInitVODUpload.startUpload();
      // 储存自定义上传方法，用于删除
      return this.canceler[item.file.uid] = {
        type: 'aliyun_Vod',
        fn: this.aliyunInitVODUpload
      };
    } else {
      // oss 直传
      return this.canceler[item.file.uid] = this.uploadService.aliyun_fileUpload(item, key, config).subscribe(async (event: HttpEvent<{}> | any) => {
        if (event.type === HttpEventType.UploadProgress) {
          if (event.total > 0) {
            (event as any).percent = (event.loaded / event.total) * 100;
          }
          // 处理上传进度条，必须指定 `percent` 属性来表示进度
          if (this.nzFileList.length) {
            item.onProgress({ percent: event.percent || 0 }, item.file);
          }
        } else if (event instanceof HttpResponse) {
          const url = `${config.host}/${config.dir}${key}`;
          // 视频第一帧截图，做封面；
          let coverUrl = '';
          if (fileType === 'video') {
            coverUrl = await this.uploadService.aliyun_cover_Upload(`${config.host}/${config.dir}${key}`);
          }
          const res = {
            code: 0,
            data: {
              url,
              coverUrl,
              fileFormat: suffix,
              fileType
            }
          };
          // 处理成功
          item.onSuccess(res, item.file, '');
        }
      },
        err => {
          // 处理失败
          item.onError(err, item.file);
        }
      );
    }
  }

  // ---------------阿里云上传结束-----------------




























  // ---------------上传中验证、完成回调-----------------

  // 上传过程回调
  handleChange(info): void {
    const response = info.file.response;
    let uploading = false;
    switch (info.file.status) {
      case 'uploading':
        uploading = true;
        break;
      case 'done':
        if (this.estimateUnderway(info.fileList)) {
          this.fileListChange.emit(this.getFileList(info.fileList));
          this.ngModelChange.emit(response);
        }
        uploading = false;
        break;
      case 'error':
        if (this.estimateUnderway(info.fileList)) {
          this.fileListChange.emit(this.getFileList(info.fileList));
          this.ngModelChange.emit(response);
        }
        uploading = false;
        break;
      case 'removed':
        if (this.estimateUnderway(info.fileList)) {
          this.fileListChange.emit(this.getFileList(info.fileList));
          this.ngModelChange.emit(response);
        }
        uploading = false;
        break;
    }
    this.uploadStatus.emit(uploading);
  }



  // 过滤上传数据
  getFileList(nzFileList): Array<any> {
    const fileList = [];
    const list = JSON.parse(JSON.stringify(nzFileList));
    list.forEach(element => {
      if (element.status === 'done' || (element.url || element.name)) {
        if (element.url || element.response.code === 0) {
          fileList.push({
            url: element.url ? element.url : element.response.data.url,
            name: element.name,
            uid: element.uid, // 不加这条，会出现多个图片被一块删除的情况
            coverUrl: element.coverUrl ? element.coverUrl : element.response.data.coverUrl,
            videoId: element.videoId ? element.videoId : element.response.data.videoId,
            fileFormat: element.fileFormat ? element.fileFormat : element.response.data.fileFormat,
            fileType: element.fileType ? element.fileType : element.response.data.fileType,
          });
        }
      }
    });
    this.formData = fileList;
    return this.formattingOutputValue(fileList) || [];
  }
  // 格式化返回参数
  formattingOutputValue(value): any {
    if (this.dataType === 'json') {
      this.outputValue = JSON.stringify(value || []);
    } else if (this.dataType === 'string') {
      this.outputValue = Array.isArray(value) && value.length && value[0].url ? value[0].url : '';
    } else if (this.dataType === 'array') {
      this.outputValue = value;
    } else {
      this.outputValue = [];
    }
    return this.outputValue;
  }


  estimateUnderway(file): any {
    let status = true;
    const fileList = file.filter((item) => item.status) || [];
    fileList.forEach(element => {
      if (element.status === 'uploading') {
        status = false;
      }
    });
    return status;
  }


  // 预览
  handlePreview = (file) => {
    const url = file.url ? file.url : file.response.data.url;
    const name = file.name;
    const type = this.utilService.getFileType(url);
    console.log('🚀 ~ file: file-upload.component.ts ~ line 554 ~ type', type);
    if (type === 'image') {
      this.previewUrl = file.url || file.thumbUrl;
      this.previewType = 'image';
      this.previewVisible = true;
    } else if (type === 'video') {
      this.previewUrl = file.url || file.thumbUrl;
      this.previewType = 'video';
      this.previewVisible = true;
    } else if (type === 'audio') {
      this.previewUrl = file.url || file.thumbUrl;
      this.previewType = 'audio';
      this.previewVisible = true;
    } else if (type === 'pdf') {
      window.open(url);
    } else {
      let newUrl: any;
      const oldReplacement = 'https://';
      if (url.includes('http://')) {
        newUrl = url.replace(oldReplacement, '');
      }
      this.downloadFileService.downloadFile(url, name || newUrl);
    }
  }
  // 下载
  nzDownload = (file) => {
    const url = file.url ? file.url : file.response.data.url;
    const name = file.name;
    let newUrl: any;
    const oldReplacement = 'https://';
    if (url.includes('http://')) {
      newUrl = url.replace(oldReplacement, '');
    }
    this.downloadFileService.downloadFile(url, name || newUrl);
  }

  // 验证格式
  beforeUpload = (file: File) => {
    let typePass = 0;
    if (this.fileType.value === null) {
      // 不限制文件格式
      typePass = 1;
    } else {
      const typeList = this.fileType.value.split(',');
      let typeHint = '';
      typeList.forEach((type, index, arr) => {
        typeHint += type;
        if (index !== arr.length - 1) { typeHint += ','; }
        if (file.type === type) { typePass++; }
      });
      if (!!!typePass) {
        // const tips = `只能上传${typeHint}格式的文件`;
        const tips = `只能上传${this.fileType.label}格式的文件`;
        const callback = async () => { };
        this.modalMessageService.errConfirm({ title: tips, ok: callback });
      }
    }

    // 验证大小
    const fileSize = this.fileSize || this.fileType.size;
    const sizePass = (file.size / 1024 / 1024) < fileSize;
    if (!sizePass) {
      const tips = `上传文件大小必须小于${fileSize}Mb`;
      const callback = async () => { };
      this.modalMessageService.errConfirm({ title: tips, ok: callback });
    }
    return !!typePass; // && !!sizePass; 限制上传图片大小（关闭）
  }




  getExtraData = () => {
    return this.extraData;
  }

  // ---------------上传中验证、完成回调-----------------
}
